<app-form-select
  *ngIf="(problemTypeSubCategories$ | async).length > 0"
  [formControl]="formControl"
  [data]="problemTypeSubCategories$ | push"
  [disabled]="disabled$ | async"
  [loading]="loading$ | push"
  [pagination]="pagination$ | push"
  [label]="label"
  [required]="(disabled$ | async) === false"
  [showSearch]="true"
  [loadOnScroll]="true"
  [selectedItem]="selectedProblemSubCategory"
  (selectSearch)="problemTypeCategorySearch($event)"
  (itemSelected)="problemTypeSubCategorySelected($event)"
  (selectLoadNextPage)="loadNextPage($event)"></app-form-select>
